__turbopack_context__.v({
  "video": "SavedSearchIllustration-module__dXtjSG__video",
});
